const initialState = {
  myAgent: null,
  scope: null,
  callFlows: null,
  presencesProfile: null,
  supervisedAgentDetails: null,
  supervisedAgentIds: null,
  callFlowsIds:null
};
export const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_AGENT_PROFILE":
      return { ...state, myAgent: action.payload };
    case "SET_SCOPE":
      return { ...state, scope: action.payload };
    case "SET_GROUPS":
      return { ...state, groups: action.payload };
    case "SET_CALL_FLOWS":
      return { ...state, callFlows: action.payload };
    case "SET_MY_AGENT_PROFILE_PRESENCES":
      return { ...state, presencesProfile: action.payload };
    case "SET_SUPERVISED_AGENT_DATA":
      return { ...state, supervisedAgentDetails: action.payload };
      case "SET_SUPERVISED_AGENT_IDS": 
        return { ...state, supervisedAgentIds: action.payload };
        case "SET_CALL_FLOWS_IDS": 
        return { ...state, callFlowsIds: action.payload };
    default:
      return state;
  }
};
